var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown',{ref:"dropdown",attrs:{"right":"","text":_vm.summaryText,"variant":"outline-dark","disabled":_vm.disabled},on:{"hide":_vm.saveChanges}},[_c('b-dropdown-form',{staticStyle:{"min-width":"320px"},on:{"submit":function($event){$event.preventDefault();$event.stopPropagation();return _vm.saveAndClose($event)}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60bd23a8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/ColumnFilter.vue
// module id = null
// module chunks = 